import { render } from "./BehalfRegistration.vue?vue&type=template&id=f97bd74e&scoped=true"
import script from "./BehalfRegistration.vue?vue&type=script&lang=js"
export * from "./BehalfRegistration.vue?vue&type=script&lang=js"

import "./BehalfRegistration.vue?vue&type=style&index=0&id=f97bd74e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f97bd74e"]])

export default __exports__